// Accordion

let accordionCount = 0;

// remove tab focus from links in container
function removeTabbing(links) {
    links.forEach((link) => {
        link.tabIndex = -1;
    });
}

// add back tab focus to links in container
function addTabbing(links) {
    links.forEach((link) => {
        link.removeAttribute('tabIndex');
    });
}

// Using a function helps isolate each accordion from the others
function makeAccordion(accordion) {
    const targetsResult = accordion.querySelectorAll('[data-accordion-item]');
    const targets = [].slice.call(targetsResult);
    const hashMap = {};

    targets.forEach((accordion) => {
        accordionCount++;
        const target = accordion.querySelector('.accordion__title');
        const content = accordion.querySelector('.accordion__text');

        if (!target) {
            return;
        }

        const container = target.parentNode;
        const accordionId = container.id ? container.id : 'info-' + accordionCount;
        const links = [].slice.call(content.querySelectorAll('a, iframe, button'));

        const targetId = target.id ? target.id : 'accordion-btn-' + accordionCount;
        if (target.id !== targetId) {
            target.id = targetId;
        }
        content.setAttribute('role', 'region');
        content.setAttribute('aria-labelledby', targetId);

        hashMap['#' + accordionId] = container;

        if (('#' + accordionId) === location.hash) {
            container.classList.add('accordion--expanded');
        }

        target.setAttribute('aria-expanded', 'false');

        target.addEventListener('click', () => {
            if (container.classList.contains('accordion--expanded')) {
                container.classList.remove('accordion--expanded');
                // remove hash
                history.replaceState('', '', window.location.pathname + window.location.search);
                removeTabbing(links);
                target.setAttribute('aria-expanded', 'false');
            } else {
                // add hash with replaceState to avoid jump and to avoid history listing
                history.replaceState(null, null, '#' + accordionId);
                container.classList.add('accordion--expanded');
                addTabbing(links);
                target.setAttribute('aria-expanded', 'true');
            }
        }, false);

        window.addEventListener('hashchange', function(e) {
            if (hashMap[location.hash]) {
                hashMap[location.hash].classList.add('accordion--expanded');
            }
        });

        if (!container.classList.contains('accordion--expanded')) {
            removeTabbing(links);
        }

    });
}

// Find all the accordions to enable
const accordions = document.querySelectorAll('[data-accordion]');
const arr = [].slice.call(accordions);

arr.forEach((accordion) => {
    makeAccordion(accordion);
});
